export default `float s=2.,r2;
    p=abs(p);
    for(int i=0; i<12;i++){
      p=1.-abs(p-1.);
      r2=(i%3==1)?1.1:1.2/dot(p,p);
      p*=r2; s*=r2;
    }
    return length(cross(p,normalize(vec3(1.0))))/s-0.005;
  }`